export const downTheRabbitHole = item => {
  if (item) {
    if (item.name) {
      return item.name
    } else {
      return downTheRabbitHole(item.ofType)
    }
  } else {
    return ""
  }
}
